// CONSTANTS are all caps.
const NS = 'ProductDetailsPage';
const CLS = 'pdp';
const PG = '.' + CLS + '-';
const CLS_LIST_ADDED = 'has-added';
const CLS_INVISIBLE = 'invisible';
const CLS_BUNDLES = CLS + '-bundles';
const EVT_SET_STORE_INFO = `${CLS}.setStore`;
const EVT_SET_RURAL_POSTCODE = `${CLS}.setRuralPostcode`;
const IN_STOCK = 'In Stock';
const LOW_IN_STOCK = 'Low in Stock';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadPg.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import slick from 'slick-carousel';
import * as utils from '../../../../global/js/utils';
import * as wishlist from '../../../../global/js/wishlist';
import * as giftRegistry from '../../../../global/js/giftRegistry';
import * as Api from '../../../../global/js/api';
import {loadNotifications} from '../../../widgets/notifications/js/loadWg';
import zoom from 'jquery-zoom';
import Handlebars from 'handlebars';
import '../../../../global/helpers/obj';
import * as dataLayer from '../../../../global/js/dataLayer';
import List from 'list.js';
import {addToCart} from '../../../../global/js/cart';
import {checkLocalStorage, saveSelectedStore} from '../../../../global/js/findInStore';
import _ from 'lodash';
import {renderNearbyStoresList} from '../../../blocks/nearbyStores/js/nearbyStores';
import {getRelatedVariants} from '../../../../global/js/utils';
import {EVENT_RELATED_UPDATE} from '../../../../global/js/constants';
import {IN_STOCK_BEFORE_CUTOFF, IN_STOCK_AFTER_CUTOFF, OOS} from '../../../../global/js/constants';
import {RelatedProducts} from './../../../blocks/relatedProducts/js/relatedProducts';
import {RelatedBundle} from '../../../blocks/relatedBundle/js/relatedBundle';
import {GuaranteedNextdayDelivery} from './guaranteedNextdayDelivery';


export function optionsSelected(type) {
	let selected = false;
	let $pg = $('[data-pg="ProductDetailsUpdate"]');
	let optionsColor = $pg.find(PG + 'variant.pdp-desc-color:not(.d-none) .pdp-options .active').attr('data-item-description');
	let optionsSize = $pg.find(PG + 'variant.pdp-desc-size:not(.d-none) .pdp-options .active').attr('data-item-description');
	switch (type) {
		case 'color':
			if (typeof optionsColor !== 'undefined') selected = true;
			break;
		case 'size':
			if (typeof optionsSize !== 'undefined') selected = true;
			break;
		case 'colorsize':
			if (typeof optionsColor !== 'undefined' && typeof optionsSize !== 'undefined') selected = true;
			break;
		default:
			selected = true;
			break;
	}
	return selected;
}
export class ProductDetailsUpdate {
	constructor($el) {
		// $el is the page node return by the loadProductDetailsPage function
		this.$el = $el;
		this.$pg = $($el);
		this.currentVariant = {
			size: '',
			color: '',
		};
		this.storeInfo = {
			storeId: '',
			storeName: '',
			regionId: '',
			branchSearch: '',
			contenLinkID: '',
		};
		this.isBundles = this.$pg.hasClass(CLS_BUNDLES);
		this.storeSelected = this.$pg.find('.click-collect .store-name');
		this.lowStock = this.$pg.data('lowStock');
		this.outOfStock = this.$pg.data('outOfStock');
		this.storeList = {};
		this.nearbyDropdown = this.$pg.find('[data-blk="NearbyStores"]');
		this.nearbyList = this.nearbyDropdown.find('.nearbyStores-list');
		this.nearbyToggle = this.nearbyDropdown.find('.nearbyStores-toggle');
		this.hasRelatedBlock = false;
		this.notClickCollectMsg = this.$pg.find('#pdp-clickCollectMessage');
		this.relatedProducts = this.$pg.find('[data-blk="RelatedProducts"]');
		this.relatedBundle = this.$pg.find('[data-blk="RelatedBundle"]');
		this.postcode = '';
		this.postcodeSelected = this.$pg.find('.standard-delivery .postcode-number');
	}

	init() {
		window.productData = {};
		this.firstRun = true;
		if (this.isBundles) {
			if (this.relatedBundle.length) {
				new RelatedBundle(this.relatedBundle[0])
					.onAfterScreenLoad(this.create.bind(this))
					.init();
			} else {
				this.create(false);
			}
		} else {
			if (this.relatedProducts.length) {
				new RelatedProducts(this.relatedProducts[0])
					.onAfterScreenLoad(this.create.bind(this))
					.init();
			} else {
				this.create(false);
			}
		}
	}

	create(hasRelatedBlock) {
		this.hasRelatedBlock = hasRelatedBlock;
		this.guaranteedNextdayDelivery = new GuaranteedNextdayDelivery();
		this.setProductDetailsPage();
		this.initFormValidationConstraints();
		this.setImageViewer();
		this.setReviews();
		this.initBundlesQtyButtons();
		this.addToCartFitAnalytics();
		utils.fixedOverviewBar();
		utils.scrollToAnchor();
		this.initCustomEvent();
		this.registerSizeSelectDropdown();
		this.toggleVariantOOS();
		this.selectNearbyStore();
		this.relatedBlockChange();
		this.relatedBundleChange();
		this.updateStickyContent();
		this.updateDeliveryDescription();
		this.updateStyleForDisclaimerText();
	}

	updateStickyContent() {
		const $stickyContent = $(this.$el).find('.pdp-desc-left');
		const top = $('.siteHeader.is-sticky').height() || 0;

		$stickyContent.css({top: `${top + 20}px`});
		$('body').addClass('product-sticky');
	}

	selectNearbyStore() {
		this.$pg.on('choose-store', '.nearbyStores', (event, item) => {
			this.nearbyDropdown.addClass('loading-spinner');
			this.storeInfo = {
				storeId: item.FulfilmentNumber,
				storeName: item.Name,
				regionId: item.RegionId,
				branchSearch: '',
				contenLinkID: item.StoreId,
			};
			saveSelectedStore(this.storeInfo, () => {
				utils.dispatchEvent('[data-wg="RegionStorePopup"]', 'regionStorePopup.setStore');
				utils.dispatchEvent('[data-pg="ProductDetailsUpdate"]', 'pdp.setStore', {resetNearbyStore: false});
				utils.dispatchEvent('[data-wg="StoreAvailNew"]', 'storeAvailNew.setRegion');
			});

		});
	}

	variantListForRange(variantCode, quantity) {
		let productType = $('[data-pg="ProductDetailsUpdate"]').attr('data-item-type');
		const relatedVariants = getRelatedVariants();
		let mainProduct = {};
		if (optionsSelected(productType)) {
			mainProduct = {
				code: variantCode,
				quantity: quantity,
			};
		}
		const variants = relatedVariants.concat(mainProduct);
		return variants;
	}

	setupNearbyStoresDropdown() {
		let $pg = $(this.$el);
		let id = `${this.storeInfo.storeId}`;
		const variantCode = $pg.attr('data-variant-code');
		let quantity = $pg.find(PG + 'desc-qty input').val();
		this.nearbyDropdown.attr('data-store-id', id);
		this.nearbyDropdown.attr('data-variant-code', variantCode);
		this.nearbyDropdown.attr('data-quantity', quantity);
		let variants = this.variantListForRange(variantCode, quantity);

		if (this.nearbyDropdown.hasClass('show')) {
			let apiUrl = this.nearbyDropdown.data('get-stock-data-same-region-by-fulfilment-number-api-endpoint');
			if (!this.nearbyDropdown.hasClass('loading-spinner')) {
				this.nearbyDropdown.addClass('loading-spinner');
			}
			Api.callApi(apiUrl, {
				fulfillmentNumber: id,
				variants,
			}).then((resp) => {
				const {
					result,
					response,
				} = resp;
				if (result === 'SUCCESS') {
					const $listStore = renderNearbyStoresList(response, $(this.nearbyDropdown), id);
					this.nearbyList.html($listStore);
					setTimeout(() => {
						this.nearbyDropdown.removeClass('loading-spinner');
					}, 500);
				}
			});
		}
	}

	resetDropdownNearbyStore() {
		if (this.nearbyToggle.hasClass('active')) {
			this.nearbyDropdown.removeClass('show');
			this.nearbyList.slideUp('slow');
			this.nearbyToggle.removeClass('active');
		}
	}

	initGeneralSpecifications() {
		const generalSpecSize = $('.general-group-sizes:not(.d-none)').find('span');
		if (generalSpecSize.length === 1) {
			generalSpecSize.addClass('selected');
			let variantCode = generalSpecSize.data('variantCode');
			this.renderSpecInfo(false, variantCode);
		}
		$('.general-collection').on('click', 'span', (e) => {
			let _this = $(e.target);
			if (!_this.hasClass('selected')) {
				// find the size on sizes list desc has variant code to trigger click
				let variantSizeCode = _this.data('variantCode');
				$(`.pdp-desc-size:not(.d-none) .pdp-option[data-variant-code=${variantSizeCode}]`).trigger('click');
			}
		});
	}

	selectGeneralSize(sz) {
		$('.general-collection span').removeClass('selected');
		sz.addClass('selected');
		let variantSzCode = sz.data('variantCode');
		this.renderSpecInfo(false, variantSzCode);
	}

	renderSpecInfo(SzRange, variantCode) {
		if (window.specificationsGeneralData) {
			const specData = window.specificationsGeneralData;
			const $specInfo = $('.general-info-item');
			const renderSpecData = function(wrapperContent, sizeRangeOrVariant, codeNumber) {
				$specInfo.html($(wrapperContent));
				let color = specData[sizeRangeOrVariant].filter((item) => Object.keys(item)[0] === codeNumber);
				if (color) {
					let data = color[0][codeNumber];
					if (!_.isEmpty(data)) {
						for (const [key, value] of Object.entries(data)) {
							// let prop = key.replace(/([A-Z])/g, ' $1').trim();
							let specRight = `<div class="pdp-info-spec-right">${value}</div>`;
							if (value === 'True') {
								specRight = '<div class="pdp-info-spec-right"><span class="icon-check"></span></div>'
							} else if (value === 'False') {
								specRight = '<div class="pdp-info-spec-right"><span class="icon-close"></span></div>'
							}
							let $li = $(`<li>
											<div class="pdp-info-spec-left">${key}</div>
											${specRight}
										</li>`);
							$specInfo.find('ul').append($li);
						}
					} else {
						$specInfo.find('ul').append($('<li>No data</li>'));
					}
				}
			};
			let keySpec = Object.keys(window.specificationsGeneralData);
			if (SzRange) {
				const contentSzRange = '<div class="title">Size Range</div><ul></ul>';
				renderSpecData(contentSzRange, keySpec[1], variantCode);
			} else {
				const contentSzInfo = '<ul></ul>';
				renderSpecData(contentSzInfo, keySpec[0], variantCode);
			}
		}
	}

	initCustomEvent() {
		let _this = this;
		this.$el.addEventListener(EVT_SET_STORE_INFO, (e, data) => {
			let resetDropdown = e.data.resetNearbyStore;
			let localStorage = checkLocalStorage();
			this.storeInfo = localStorage.storeInfo;
			this.storeSelected.each(function(index, el) {
				$(el).html(`&nbsp;-&nbsp;${_this.storeInfo.storeName}`);
			});
			if (resetDropdown) {
				this.resetDropdownNearbyStore();
			}
			this.checkStockStatus();
			this.updateDeliveryDescription();
		});

		this.$el.addEventListener(EVT_SET_RURAL_POSTCODE, (e) => {
			this.displayRuralDelivery();
		});
	}

	updateDeliveryDescription() {
		const localStorage = checkLocalStorage();
		this.storeInfo = this.storeInfo || localStorage.storeInfo;
		const hasStoreSelected = !!this.storeInfo.storeName;
		const productType = this.$pg.attr('data-item-type');
		const cssIsNotStore = 'is-not-store';
		const cssIsNotProductOption = 'is-not-product-option';
		if (['size', 'colorsize'].includes(productType)) {
			const hasVariantSelected = $('.pdp-option.item-size.active').length;
			if (hasVariantSelected) {
				this.$pg.removeClass(cssIsNotProductOption);
			} else {
				this.$pg.addClass(cssIsNotProductOption);
			}
		}
		if (hasStoreSelected) {
			this.$pg.removeClass(cssIsNotStore);
		} else {
			this.$pg.addClass(cssIsNotStore);
		}
	}

	displayRuralDelivery() {
		const $liStandard = $('.standard-delivery');
		const $rural = $liStandard.find('.rural-delivery');
		const $standard = $liStandard.find('.initial');
		const $ruralChangePostcode = $liStandard.find('.rural-changePostcode');
		this.postCode = window.localStorage.getItem('postcode');
		const postcodeType = window.localStorage.getItem('postcodeType');
		if (this.postCode) {
			if (postcodeType === 'rural') {
				$standard.addClass('d-none');
				$ruralChangePostcode.text('Change Delivery Postcode');
				$rural.removeClass('d-none');
			} else {
				$rural.addClass('d-none');
				$standard.removeClass('d-none');
				$ruralChangePostcode.text('Change Delivery Postcode');
			}
			this.postcodeSelected.html(`&nbsp;-&nbsp;Postcode ${this.postCode}`);
		} else {
			$rural.removeClass('d-none');
			$ruralChangePostcode.text('Set Delivery Postcode');
			$standard.removeClass('d-none');
			$liStandard.find('.postcode-number').html('');
		}
		if (!$liStandard.hasClass('loaded')) {
			$liStandard.find('.loading').addClass('d-none');
			$liStandard.find('.delivery-content').removeClass('d-none');
			$liStandard.addClass('loaded');
		}
	}

	registerSizeSelectDropdown() {
		const _this = this;
		const $pg = $(this.$el);
		const AUTO_SELECT_QUANTITY = 1;
		$pg.on('change', '.selectbox', function(event, {variantFormattedcode, variantPrice}) {
			const $bundlesItemVariant = $(this).closest('.pdp-bundlesItem--variant');
			const $quantity = $bundlesItemVariant.find('.quantityInput input');
			const $quantityBtnDown = $bundlesItemVariant.find('.quantityInput .btn-down');
			const price = variantPrice ? `$${parseFloat(variantPrice).toFixed(2)}` : '';
			const isZeroQuantity = $quantity.val() == 0;

			$bundlesItemVariant.data('variant-formattedcode', variantFormattedcode);
			$bundlesItemVariant.attr('data-variant-formattedcode', variantFormattedcode);
			$bundlesItemVariant.find('.pdp-bundlesItem-price--original').text(price);
			if (isZeroQuantity) {
				$quantity.val(AUTO_SELECT_QUANTITY);
				$quantityBtnDown.removeClass('disabled');
				_this.checkFreeDelivery();
			}
		});
	}

	relatedBlockChange() {
		if (!this.isBundles && this.hasRelatedBlock && window.enableSameDayClickAndCollect) {
			this.$pg.on(EVENT_RELATED_UPDATE, this.relatedProducts, (event, item) => {
				let relatedItemNotCnC = $('.relatedProducts__item.enable-add-cart[data-notclickcollect="true"]') || [];
				let mainProductNotCnC = JSON.parse($('.click-collect.standard').attr('data-clickcollectnotavailable'));
				let selectedSizeNotCnC = $('.pdp-options.sizes .pdp-options.active[data-noclickcollect="true"]') || [];
				let selectedColorNotCnC = $('.pdp-options.colors .pdp-options.active[data-noclickcollect="true"]') || [];
				let selectedVariantNotCnC = selectedSizeNotCnC.length || selectedColorNotCnC.length;
				if (relatedItemNotCnC.length || mainProductNotCnC || selectedVariantNotCnC) {
					$('.click-collect').each(function(index, el) {
						if (!$(el).hasClass('d-none')) {
							$(el).addClass('d-none');
						}
					});
					$('.click-collect.standard').removeClass('d-none');
					$('.cc-standard').hide();
					this.notClickCollectMsg.show();
					this.nearbyDropdown.hide();
					// check au vendor
					if (window.enableAustraliaSupplier) {
						let relatedItemAUVendor = $('.relatedProducts__item.enable-add-cart[data-australianvendor="true"]') || [];
						let selectedSizeAUVendor = $('.pdp-options.sizes .pdp-options.active[data-australianvendor="true"]') || [];
						let selectedColorAUVendor = $('.pdp-options.colors .pdp-options.active[data-australianvendor="true"]') || [];
						let genericVariant = this.producItemInfo.variants[0].isAustralianVendor;
						let selectedVariantAUVendor = selectedSizeAUVendor.length || selectedColorAUVendor.length || genericVariant;
						if (selectedVariantAUVendor || relatedItemAUVendor.length) {
							this.setAUVendor(true);
						} else {
							this.setAUVendor(false);
						}
					}
				} else {
					this.notClickCollectMsg.hide();
					$('.cc-standard').show();
					this.checkStockStatus();
				}
				this.checkFreeDelivery();
			});
		}
	}

	relatedBundleChange() {
		if (this.isBundles && this.hasRelatedBlock && window.enableSameDayClickAndCollect) {
			this.$pg.on(EVENT_RELATED_UPDATE, this.relatedBundle, (event, item) => {
				// check au vendor
				if (window.enableAustraliaSupplier) {
					const relatedItemAUVendor = $('.relatedBundle__item.enable-add-cart[data-notclickcollect="true"][data-australianvendor="true"]') || [];
					if (relatedItemAUVendor.length) {
						this.setAUVendor(true);
					} else {
						this.setAUVendor(false);
					}
				}
				this.checkFreeDelivery();
			});
		}
	}

	setStockCollectionRange() {
		const _this = this;
		const $pg = $(this.$el);
		const relatedVariants = getRelatedVariants(_this.relatedProducts);
		const productType = $pg.attr('data-item-type');
		let url = '/api/findinstore/check-click-and-collect-store-status';
		let variantCode = $pg.attr('data-variant-code');
		let quantity = parseInt($pg.find(PG + 'desc-qty input').val());
		let variants = _this.variantListForRange(variantCode, quantity);

		let data = {
			fulfillmentNumber: this.storeInfo.storeId,
			isHeavy: window.isHeavy,
			variants,
		};
		if (_this.storeInfo.storeId) {
			Api.callApi(url, data).then((resp) => {
				if (resp && resp.result === 'SUCCESS') {
					const {
						pickupStatus,
					} = resp.response;
					_this.checkStoreDataNull(() => _this.setClickCollect(pickupStatus), true);
				} else {
					_this.checkStoreDataNull(() => {}, false);
				}
			});
		}
	}

	checkStoreDataNull(func, respStatus) {
		const $storeNodata = $('.store-noData');
		if (respStatus) {
			if (!$storeNodata.hasClass('d-none')) {
				$storeNodata.addClass('d-none');
			}
			func();
		} else {
			$storeNodata.removeClass('d-none');
		}
	}

	checkStockStatus(checkedStock = false) {
		const _this = this;
		const $pg = $(this.$el);
		const productCode = $pg.attr('data-item-code');
		const productType = $pg.attr('data-item-type');
		let endpoint = `/api/findinstore/store-variant-detail?productCode=${productCode}&fulfilmentNumber=${_this.storeInfo.storeId}`;
		if (!_this.firstLoadNotCnc()) {
			if (_this.hasRelatedBlock) {
				_this.setStockCollectionRange();
			} else {
				if (_this.storeList.storeId === `${_this.storeInfo.storeId}`) {
					_this.setClickCollect();
				} else if (optionsSelected(productType)) {
					if (_this.storeInfo.storeId) {
						Api.getApi(endpoint).then((data) => {
							if (data.result === 'SUCCESS') {
								let storeResult = data.response.storeList;
								let storeSelected = storeResult[0] || {};
								let setStockStatus = (storeSelected) => {
									_this.storeList = storeSelected;
									_this.setClickCollect();
									_this.checkHeavy();
								};
								_this.checkStoreDataNull(() => setStockStatus(storeSelected), storeResult.length);
							}
						});
					}
				}
			}
		} else {
			// check not CnC for first load, case api check stock return after check data-noClickCollect
			if (productType !== 'generic' && !checkedStock) {
				_this.checkDataNotClickCollect();
			}
		}
	}

	firstLoadNotCnc() {
		let isNotCnc = false;
		let $pg = $(this.$el);
		let optionsColor = $pg.find(PG + 'variant.pdp-desc-color:not(.d-none) .pdp-options .pdp-option');
		let optionsSize = $pg.find(PG + 'variant.pdp-desc-size:not(.d-none) .pdp-options .pdp-option');
		let colorSelected = $pg.find(PG + 'variant.pdp-desc-color .pdp-options .pdp-option.active');
		let sizeSelected = $pg.find(PG + 'variant.pdp-desc-size .pdp-options .pdp-option.active');
		const isNoClickCollect = function(option) {
			return option.attr('data-noclickcollect') === 'true';
		};
		switch ($pg.attr('data-item-type')) {
			case 'color':
				if (optionsColor.length === 1) {
					if (isNoClickCollect(optionsColor)) {
						isNotCnc = true;
					}
				} else if (isNoClickCollect(colorSelected)) {
					isNotCnc = true;
				}
				break;
			case 'size':
				if (optionsSize.length === 1) {
					if (isNoClickCollect(optionsSize)) {
						isNotCnc = true;
					}
				} else if (isNoClickCollect(sizeSelected)) {
					isNotCnc = true;
				}
				break;
			case 'colorsize':
				if (optionsSize.length === 1) {
					if (isNoClickCollect(optionsSize)) {
						isNotCnc = true;
					}
				} else if (isNoClickCollect(sizeSelected)) {
					isNotCnc = true;
				}
				break;
			case 'generic':
				{
					let genericNotCnC = $('.click-collect.standard').attr('data-clickcollectnotavailable');
					if (genericNotCnC === 'true') {
						isNotCnc = true;
					}
				}
				break;
			default:
				isNotCnc = false;
				break;
		}
		return isNotCnc;
	}

	checkHeavy() {
		const $pg = $(this.$el);
		const productType = $pg.attr('data-item-type');
		const variants = (window.productDetailsJson || { variants: [] }).variants.reduce((acc, cur) => {
			acc[cur.code] = cur;
			return acc;
		}, {});

		const actionByType = {
			colorsize: () => {
				const code = $('.pdp-desc-size .pdp-option.item-size.is-active-variant:visible').attr('data-variant-code');
				const variantSelected = (variants[code] || { isHeavyItem: false });

				return variantSelected.isHeavyItem;
			},
			color: () => {
				const code = $('.pdp-desc-color .pdp-option.is-active-variant:visible').attr('data-variant-code');
				const variantSelected = (variants[code] || { isHeavyItem: false });

				return variantSelected.isHeavyItem;
			},
			size: () => {
				const code = $('.pdp-desc-size .pdp-option.item-size.is-active-variant:visible').attr('data-variant-code');
				const variantSelected = (variants[code] || { isHeavyItem: false });

				return variantSelected.isHeavyItem;
			},
		};
		if (actionByType[productType]) {
			const isHeavy = actionByType[productType]();
			this.setHeavyItem(isHeavy);
		}
	}

	setClickCollect(status) {
		let storeSelected = this.storeList;
		if (storeSelected) {
			let stt = status === undefined ? this.getStockStatus(storeSelected) : status;
			// reset status for dropdown
			this.setupNearbyStoresDropdown();
			$('.click-collect').each(function(index, el) {
				if (!$(el).hasClass('d-none')) {
					$(el).addClass('d-none');
				}
			});
			let checkTime = (cutOffTime, currentTime) => {
				if (!cutOffTime && !currentTime) return false;
				let regex = new RegExp(':', 'gi');
				let end = parseInt(cutOffTime.replace(regex, ''), 10);
				let onTime = false;
				let current = parseInt(currentTime.replace(regex, ''), 10);
				if (current < end) {
					onTime = true;
				}
				return onTime;
			};
			switch (stt) {
				case OOS:
					$('.click-collect.out-of-stock').removeClass('d-none');
					this.nearbyDropdown.show();
					break;
				case IN_STOCK:
				case IN_STOCK_BEFORE_CUTOFF:
				case IN_STOCK_AFTER_CUTOFF:
					if (checkTime(storeSelected.cutOffTime, storeSelected.currentTime) || stt === IN_STOCK_BEFORE_CUTOFF) {
						$('.click-collect.pick-up-available').removeClass('d-none');
					} else {
						$('.click-collect.in-stock').removeClass('d-none');
					}
					this.nearbyDropdown.show();
					break;
				default:
					$('.click-collect.standard').removeClass('d-none');
					this.nearbyDropdown.hide();
					break;
			}
			this.checkAUVendor();
		}
	}

	getStockStatus(storeSelected) {
		let stockStatus = (stockOnHand, quantity) => {
			let status = IN_STOCK;
			let remainingStock = stockOnHand - quantity;
			if (remainingStock < this.outOfStock) {
				status = OOS;
			}
			return status;
		};
		let $pg = $(this.$el);
		let optionsColor = $pg.find(PG + 'variant.pdp-desc-color:not(.d-none) .pdp-options .active').attr('data-item-description');
		let optionsSize = $pg.find(PG + 'variant.pdp-desc-size:not(.d-none) .pdp-options .active').attr('data-item-description');
		let stt = '';
		let quantity = parseInt($pg.find(PG + 'desc-qty input').val());

		switch (storeSelected.productType) {
			case 'color':
				if (storeSelected.colorList && storeSelected.colorList.length > 0) {
					let item = storeSelected.colorList.filter((color) => color.colourName === optionsColor)[0];
					stt = stockStatus(item.stockOnHand, quantity);
				}
				break;
			case 'size':
				if (storeSelected.sizeList && storeSelected.sizeList.length > 0) {
					let item = storeSelected.sizeList.filter((size) => size.sizeDescription === optionsSize)[0];
					stt = stockStatus(item.stockOnHand, quantity);
				}
				break;
			case 'colorsize':
				if (storeSelected.colorList && storeSelected.colorList.length > 0) {
					let item = storeSelected.colorList.filter((color) => color.colourName === optionsColor)[0];
					if (item) {
						let variant = item.sizes.filter((sz) => sz.sizeDescription === optionsSize)[0];
						if (variant) stt = stockStatus(variant.stockOnHand, quantity);
						else stt = 'standard';
					}
				}
				break;
			default:
				// generic
				stt = stockStatus(storeSelected.stockOnHand, quantity);
				break;
		}
		return stt;
	}

	addToCartFitAnalytics() {
		let fitAnalytics = window.fitAnalyticsData;
		if (fitAnalytics && productDetailsJson) {
			fitAnalytics.operations.addToCart = (productId, size) => {
				// variantId
				if (!size && productDetailsJson.variants) {
					let variantSelected = productDetailsJson.variants.find((v) => v.formattedCode === productId);
					if (variantSelected) this.addToBag(variantSelected.code);
				} else {
					// productId
					if (productDetailsJson.colors) {
						let listItems = productDetailsJson.colors.items;
						let itemSelected = listItems.find((item) => item.productCode.includes(productId));
						if (itemSelected && itemSelected.sizes) {
							let sizeSelected = itemSelected.sizes.items.find((sz) => sz.sizeDescription === size );
							if (sizeSelected) this.addToBag(sizeSelected.sku, size);
						}
					}
				}
			};
		}
	}

	setProductDetailsPage() {
		// Add Some logic here
		let That = this;
		let $pg = $(this.$el);
		That.price = {};
		That.producItemInfo = {};

		That.firstloadSite = true;
		let localStorage = checkLocalStorage();
		this.storeInfo = localStorage.storeInfo;
		if (this.storeInfo.storeName) {
			this.storeSelected.each(function(index, el) {
				$(el).html(`&nbsp;-&nbsp;${That.storeInfo.storeName}`);
			});
		}

		this.displayRuralDelivery();
		this.initFreeShippingOnMinPrice();

		// show spinners
		$('.loading-spinner').addClass('is-active');

		// set default product options in case there is only one option
		$pg.find(PG + 'variant:not(.d-none)').each((index, ele) => {
			let $ele = $(ele);
			let options = $ele.find(PG + 'option');
			if (options.length === 1) {
				options.addClass('active is-active-variant');
			} else {
				// productType: color/ colorsize, auto select first color
				if ($ele.hasClass('pdp-desc-color')) {
					options.first().addClass('active is-active-variant');
				}
			}
		});
		if (!this.isBundles) {
			That.initGeneralSpecifications();
		}
		That.getProdImgVariations();
		That.checkPriceDisCount();
		let noCnc = $('.click-collect.standard').data('clickcollectnotavailable');
		if (!noCnc) {
			That.checkStockStatus();
		}



		// moved this function call within 'getProdImgVariations' so it waits until the api call complete to set the 'data-variant-code'
		// That.getVariantCode();

		// get clicks on options
		$pg.find(PG + 'option').on('click', function(e, bundleFirstLoad = false) {
			if (!$(this).hasClass('is-active-variant')) {
				That.wasNotActive = true;
			}
			// keep the current selected size
			That.currentVariant.size = $pg.find(PG + 'option.item-size.active.is-active-variant:visible').attr('data-item-description') || '';
			if ($(this).parent().hasClass('colors')) {
				That.currentVariant.color = $(this).attr('data-variant-code');
				// when change the color, if the selected size existed then make the size 'active'
				let sizeNodeList = $pg.find(`[data-parent-itemid="${That.currentVariant.color}"]`).find(PG + 'options').children();
				let sizeGeneralList = $pg.find(`.general-group-sizes[data-parent-itemid="${That.currentVariant.color}"]`).children();
				for (let i=0; i<sizeNodeList.length; i++) {
					if ($(sizeNodeList[i]).attr('data-item-description') == That.currentVariant.size) {
						// keep existing the size selection
						$(sizeNodeList[i]).addClass('active');
						$(sizeNodeList[i]).addClass('is-active-variant');
						$(sizeGeneralList[i]).addClass('selected');
					} else {
						// remove active selection
						$(sizeNodeList[i]).removeClass('active');
						$(sizeNodeList[i]).removeClass('is-active-variant');
						$(sizeGeneralList[i]).removeClass('selected');
					}
				}
			} else {
				That.currentVariant.size = $(this).attr('data-item-description');
			}

			let variantCode;
			let curVariantCode = $pg.attr('data-variant-code');

			let desc = $(this).data('itemDescription');
			let wpDetail = $(this).closest(PG + 'desc-right');

			if ($(this).closest('.pdp-desc-color')) {
				$(this).closest(PG + 'desc-color').find('.variant-heading-left span').text(desc);
			}
			$(this).closest(PG + 'options').find(PG + 'option:not(.slide)').removeClass('active');

			// cleanup styles
			$(this).closest(PG + 'options').find(PG + 'option').removeClass('is-active-variant');
			$(this).addClass('active');
			$(this).addClass('is-active-variant');

			// only do one ajax call
			const productType = $pg.attr('data-item-type');
			if (productType !== 'colorsize') {
				if ($(this).hasClass('item-size')) {
					variantCode = $(this).data('sku');
				}
			}

			if (productType !== 'color' || productType !== 'size') {
				variantCode = $(this).data('sku');
			}


			if ($(this).hasClass('has-sizes')) {
				let itemCode = $(this).data('variantCode');
				$pg.find(`.general-group-sizes[data-parent-itemid]`).addClass('d-none');
				$pg.find('.general-group-sizes[data-parent-itemid="'+ itemCode +'"]').removeClass('d-none');
				wpDetail.find('[data-parent-itemid]').addClass('d-none');
				wpDetail.find('[data-parent-itemid="'+ itemCode +'"]').removeClass('d-none');
				variantCode= $pg.find('.pdp-desc-size:not(.d-none) .sizes .is-active-variant').attr('data-sku');

				// Switch color select, select size not yet
				if (!variantCode) {
					variantCode = itemCode;
					// Size Range change when switch color
					if (!That.firstloadSite && !That.isBundles) {
						let colorCode = $(this).data('colourCode');
						That.renderSpecInfo(true, colorCode);
					} else {
						That.firstloadSite = false;
					}
				} else {
					let generalSizeActive = $(`.general-collection span[data-variant-code="${variantCode}"]`);
					if (generalSizeActive.length) {
						That.selectGeneralSize($(generalSizeActive));
					}
				}

				// Update fitAnalys
				let fitAnalytics = window.fitAnalyticsData;
				if (fitAnalytics && productDetailsJson) {
					let productCode = $(this).data('productCode');
					let colourCode = $(this).data('colourCode');
					let colourName = $(this).data('itemDescription');
					if (productCode) {
						let prefixProductCode = productCode.match(/^[^_]_/);
						fitAnalytics.currentProductId = productCode.replace(prefixProductCode, '').replace('_00', '') + colourName;
					}
					if (colourCode) {
						let selectedVariant = productDetailsJson.variants.filter((item) => item.code === variantCode)[0];
						if (selectedVariant) {
							fitAnalytics.mainThumbnail = location.origin + selectedVariant.images[0].thumb;
						}
						let selectedItem = productDetailsJson.manufacturedSizes.filter((item) => item.colourCode === colourCode)[0];
						if (selectedItem) {
							fitAnalytics.currentColour = colourName;
							let listSize = selectedItem.sizes;
							let updatedListSize = [];
							for (let i = 0; i < listSize.length; i ++) {
								let sz = {value: listSize[i].value, isAvailable: listSize[i].isAvailable};
								updatedListSize.push(sz);
							}
							fitAnalytics.sizes = updatedListSize;
						}
					}
				}
			} else {
				let generalSz = $(`.general-collection span[data-variant-code="${variantCode}"]`);
				if (generalSz.length) {
					That.selectGeneralSize($(generalSz));
				} else if (productType === 'color') {
					That.renderSpecInfo(false, variantCode);
				}
			}

			$pg.attr('data-variant-code', variantCode);

			// set price
			if (That.saleAvailability !== 'ISONP') {
				That.setPrice();
				That.setBonusBuy();
				That.checkPriceDisCount();
				That.setAppearanceBundlesVariants();
			}

			// trigger variant changed event on the page dom element
			// trigger variant class change
			// happens only if a different variant is clicked
			// if (!$(this).hasClass('is-active-variant')) {
			// TODO: Refactor
			if (!bundleFirstLoad) {
				if ((curVariantCode !== variantCode) || That.wasNotActive) {
					$pg.trigger('variantChanged');
				}
			}
			// }

			That.wasNotActive = false;

			// Check variant not click collect
			const noclickcollect = $(this).attr('data-noclickcollect');
			if (this.notClickCollectMsg && noclickcollect) {
				const displayMsg = JSON.parse(noclickcollect) ? 'block' : 'none';
				this.notClickCollectMsg.css('display', displayMsg);
				let productNotCnC = $('.click-collect.standard').attr('data-clickcollectnotavailable');
				if (displayMsg === 'none' && productNotCnC === 'true') {
					$('.cc-standard').css('display', 'block');
				}
			}
		});

		this.setFirstColourBundle();

		$pg.on('click', '.pdp-desc-action .add-to-cart', function() {
			if (That.saleAvailability === 'ISOOP' || That.saleAvailability === 'ISONP') {
				window.location.assign(That.contactUsPageLink);
			} else {
				That.addToBag();
			}
		});

		// call the product images variation API

		// init options click on the active ones so that variant code gets updated
		$pg.find('.pdp-variant:not(.d-none) .pdp-option.is-active-variant').each(function(i, el) {
			$(el).trigger('click');
			That.checkWishAndGiftLists();
			That.checkFreeDelivery();
		});
		That.checkAUVendor();
		// get clicks on video thumbs
		$pg.on('click', '.video-player', function() {
			let src = $(this).attr('data-src');
			let video = $pg.find('#popupVideo')[0];
			video.src = src;
			$pg.find('#videoPlayerModal').modal('show');
			video.load();
			video.play();
		});

		$pg.on('hidden.bs.modal', '#videoPlayerModal', function() {
			let video = $pg.find('#popupVideo')[0];
			video.pause();
		});

		$pg.on('click', `.wishlistBtn`, function() {
			That.handleWishlistBtn($(this));
		});

		$pg.on('click', `.addToGiftBtn`, function() {
			That.handleGiftRegistry($(this));
		});

		let hasUserAddedReview = $(document).find('#hasUserAddedReview').val();

		if (hasUserAddedReview && (hasUserAddedReview == true || hasUserAddedReview == 'true')) {
			$(document).find('.reviewForm-writeBtn').addClass('has-added').html('Review Added');
		}

		$(document).on('shown.bs.modal', '#reviewFormModal', function() {
			// prefill the email and nickname values if they exist
			let userEmail = $(document).find('#userEmail').val();
			let userNickName = $(document).find('#userNickName').val();
			if (userEmail && userEmail != '') {
				$(this).find('#reviewEmail').val(userEmail);
			}
			if (userNickName && userNickName != '') {
				$(this).find('#reviewName').val(userNickName);
			}
		});

		// $pg.find(`.prod-title`).parent().find('hr:first').css({
		// 	marginTop: '36px',
		// });

		// Check wishlist for generic product
		if (!$('.pdp-variant').length) {
			That.checkWishAndGiftLists();
		}
		window.PDP = That;
	}

	setHeavyItem(isItemHeavy = false) {
		let sameDayList = $('.pdp-extra-info ul');
		const heavyClass = 'is-heavy-uncheck';
		const CSS_HEAVY = 'is-heavy-product';
		if (sameDayList && typeof(window.enableChangeHeavyItemWording)) {
			if (isItemHeavy) {
				if (window.enableChangeHeavyItemWording) {
					sameDayList.removeClass(heavyClass);
					this.nearbyDropdown.removeClass(heavyClass);
				} else {
					sameDayList.hasClass(heavyClass) ? '' : sameDayList.addClass(heavyClass);
					this.nearbyDropdown.hasClass(heavyClass) ? '' : this.nearbyDropdown.addClass(heavyClass);
				}
				this.$pg.addClass(CSS_HEAVY);
			} else {
				sameDayList.removeClass(heavyClass);
				this.nearbyDropdown.removeClass(heavyClass);
				this.$pg.removeClass(CSS_HEAVY);
			}
		}
		this.checkAUVendor();
	}

	setFirstColourBundle() {
		if (this.isBundles) {
			const $pg = $(this.$el);
			const $colour = $pg.find(`.colors ${PG}option`);
			if ($colour.length) {
				$colour.first().trigger('click', true);
			}
		}
	}

	initFreeShippingOnMinPrice() {
		const isFreeShip = _.get(window, 'spendAmountProductShippingPromotion.HasShippingPromotion', false);
		this.displayShippingFree(isFreeShip);
	}

	checkFreeDelivery() {
		const That = this;
		const $pg = $(this.$el);
		let productType = $pg.attr('data-item-type');
		let amountShippingPromo = window.spendAmountProductShippingPromotion;
		let amountExcludedVariationCodes = amountShippingPromo.ExcludedVariationCodes || [];
		let quantityShippingPromo = window.buyQuantityShippingPromotionInfo;
		let qtyExcludedVariation = quantityShippingPromo.ExcludedVariationCodes || [];
		let total = 0;
		let quantity = 0;
		const hasSpendAmountFreeShip = amountShippingPromo && amountShippingPromo.AmountGetFreeShipping > 0;
		const hasBuyQuantityFreeShip = quantityShippingPromo && quantityShippingPromo.QuantityGetFreeShipping > 0;

		if (hasSpendAmountFreeShip || hasBuyQuantityFreeShip) {
			if (optionsSelected(productType)) {
				let qty = parseInt($pg.find('.quantityInput input').val());
				let price = 0;
				let variantCode = $pg.attr('data-variant-code');
				let isAmountFreeShipping = !amountExcludedVariationCodes.includes(variantCode);
				let isQtyFreeShipping = !qtyExcludedVariation.includes(variantCode);
				if (isAmountFreeShipping) {
					if (productType === 'generic') {
						price = parseFloat(That.price[variantCode].salePrice.amount);
					} else {
						price = parseFloat(That.variantPrice);
					}
				}
				if (isQtyFreeShipping) {
					quantity = quantity + qty;
				}
				total = price * qty;
			}
			if (this.hasRelatedBlock) {
				const checkFreeDeliveryRelated = (label) => {
					let selectedItems = $(`.${label}__item.enable-add-cart`);
					let _total = 0;
					let _quantity = 0;
					for (let i=0; i < selectedItems.length; i++) {
						let item = $(selectedItems[i]);
						let variantCode = item.attr('data-sku');
						let isAmountFreeShipping = !amountExcludedVariationCodes.includes(variantCode);
						let isQtyFreeShipping = !qtyExcludedVariation.includes(variantCode);
						let qty = parseInt(item.find(`.${label}__input .quantityInput input`).val());
						if (qty > 0 && isAmountFreeShipping) {
							let priceDiscount = parseFloat(item.find(`.${label}__price .price-discount`).text().replace('$', ''));
							let normalPrice = parseFloat(item.find(`.${label}__price`).text().replace('$', ''));
							let itemPrice = isNaN(priceDiscount) ? normalPrice : priceDiscount;
							_total = _total + (itemPrice * qty);
						}
						if (qty > 0 && isQtyFreeShipping) {
							_quantity = _quantity + qty;
						}
					}
					return {
						total: _total,
						quantity: _quantity,
					};
				};
				if (this.isBundles) {
					const bundle = checkFreeDeliveryRelated('relatedBundle');
					quantity = bundle.quantity;
					total = bundle.total;
				} else {
					const relatedProd = checkFreeDeliveryRelated('relatedProducts');
					quantity = quantity + relatedProd.quantity;
					total = total + relatedProd.total;
				}
			}

			if (total) {
				const isFreeShip = (hasSpendAmountFreeShip && total >= amountShippingPromo.AmountGetFreeShipping) || (hasBuyQuantityFreeShip && quantity >= quantityShippingPromo.QuantityGetFreeShipping)
				this.displayShippingFree(isFreeShip);
			} else {
				this.initFreeShippingOnMinPrice();
			}
		}
	}

	displayShippingFree(isFreeShip) {
		const $page = $(this.$el);
		const $shippingDefaultLabel = $page.find('.pdp-desc-delivery ul li .shipping-default');
		const $shippingPromoLabel = $page.find('.pdp-desc-delivery ul li .shipping-promotion');
		const includedShippingMethodIds = _.get(window, 'spendAmountProductShippingPromotion.IncludedShippingMethodIds', []);

		$shippingPromoLabel.addClass('d-none')
		$shippingDefaultLabel.removeClass('d-none');

		if (isFreeShip) {
			const shippingPrice = $(`[data-shipping-id]`);
			shippingPrice.each((index, item) => {
				const $item = $(item);
				const id = $item.attr('data-shipping-id');
				const $shippingDefault = $item.find('.pdp-desc-delivery-detail .shipping-default');
				const $shippingPromo = $item.find('.pdp-desc-delivery-detail .shipping-promotion');

				if (includedShippingMethodIds.includes(id)) {
					$shippingDefault.addClass('d-none');
					$shippingPromo.removeClass('d-none');
				} else {
					$shippingDefault.removeClass('d-none');
					$shippingPromo.addClass('d-none');
				}
			});
		} else {
			this.guaranteedNextdayDelivery.$el.removeClass('d-none');
		}
	}

	checkPriceDisCount() {
		let price = $('.pdp-desc-price');
		if (price.find('.productItem-price--original').length && price.find('.productItem-price--discount').length) {
			price.find('.productItem-price--original').addClass('productItem-price--default').removeClass('productItem-price--original');
		}
	}

	setVisibleProduct() {
		let $pg = $(this.$el);
		let colors = $pg.find(PG + 'options.colors').find(PG + 'option');

		if (colors.length > 0) {
			let $firstColor = colors.first();
			let selVariantCode = $firstColor.data('variant-code');
			let $parentSize = $pg.find(`${PG}variant[data-parent-itemid="${selVariantCode}"]`);

			// $firstColor.trigger('click');

			if ($parentSize.length > 0) {
				let sizes = $parentSize.find(`${PG}options.sizes .item-size`);

				// if there's only one size option, tick it
				if (sizes.length === 1) {
					sizes.first().trigger('click');
				}
			}
		}
	}

	checkDataNotClickCollect() {
		const That = this;
		const $pg = $(this.$el);
		// Check click collect available
		let optionsSelected = $pg.find(PG + 'variant.pdp-desc-size:not(.d-none) .pdp-options .active');
		let productType = $pg.attr('data-item-type');
		let $mesgNotCnC = $('#pdp-clickCollectMessage');
		let $CnCStandard = $('.cc-standard');
		if (productType === 'color') {
			optionsSelected = $pg.find(PG + 'variant.pdp-desc-color .pdp-options .active');
		}
		let noCnC = optionsSelected.attr('data-noclickcollect');
		if (optionsSelected.length) {
			let relatedItemNotCnC = $('.relatedProducts__item.enable-add-cart[data-notclickcollect="true"]') || [];
			if (noCnC === 'true' || relatedItemNotCnC.length) {
				this.nearbyDropdown.hide();
				$('.click-collect').each(function(index, el) {
					if (!$(el).hasClass('d-none')) {
						$(el).addClass('d-none');
					}
				});
				$('.click-collect.standard').removeClass('d-none');
				$CnCStandard.hide();
				$mesgNotCnC.show();
				That.checkFreeDelivery();
			} else {
				$CnCStandard.show();
				$mesgNotCnC.hide();
				That.checkStockStatus(true);
				That.checkFreeDelivery();
			}
		} else {
			if (productType === 'colorsize') {
				$CnCStandard.show();
				$mesgNotCnC.hide();
			} else {
				That.checkStockStatus();
			}
			That.checkFreeDelivery();
		}
		That.checkHeavy();
	}

	updateStyleForDisclaimerText() {
		$('[data-binding-color]').each((index, element) => {
			const path = element.dataset.bindingColor;
			const color = _.get(window, path, null);
			if (color) {
				const style = utils.getStyle({ color });
				$(element).attr('style', style);
			}
		});
	}

	getProdImgVariations() {
		const That = this;
		const $pg = $(this.$el);
		// let itemCode = $pg.data('itemCode');

		let data = {};

		if (typeof productDetailsJson != 'undefined') {
			// Defined globally by BE
			// eslint-disable-next-line no-undef
			data = productDetailsJson;

			That.saleAvailability = data.saleAvailability;
			That.contactUsPageLink = data.contactUsPageLink;
		}

		let res = data;
		let slider = $pg.find(PG + 'imgSlider');
		let thumbs = $pg.find(PG + 'imgThumbs');

		// get display price
		if (res.displayPrice) {
			That.displayPrice = res.displayPrice;
			$pg.find('.pdp-desc-price').html(res.displayPrice);
		}

		// get Bonus Buy Badges
		if (res.bonusBuyBadges) {
			That.bonusBuyBadges = res.bonusBuyBadges;
			That.setBonusBuy();
		}

		// Price should display "displayPrice"
		// Part Payment options (Laybuy, Afterpay, Humm) shouldn't be displayed
		if (That.saleAvailability === 'ISONP') {
			$pg.find(PG + 'paymentInfo').addClass('d-none');
		}

		// "Add to Cart" button changes to "Contact Us" using
		if (That.saleAvailability === 'ISOOP' || That.saleAvailability === 'ISONP') {
			$pg.find('.add-to-cart').text('Contact Us');
		}

		if (res.paymentInfo) {
			That.paymentInfoInit = res.paymentInfo;
		}

		// main slider is the (res.images)
		if (res.images && res.images.length > 0) {
			for (let i = 0; i < res.images.length; i++) {
				let imgSrc = res.images[i].detail;
				let imgThumbSrc = res.images[i].thumb;
				let imgZoomSrc = res.images[i].zoom;
				let alt = res.images[i].alt || res.title || '';
				let videoSrc = res.images[i].video || '';

				let slide = `
					<div class="${CLS}-slide" ${i === 0 ? 'itemprop="image"' : ''}>
						${videoSrc ? '<span class="icon-play"></span>' : ''}
						<img data-zoom-image="${imgZoomSrc}" src="${imgSrc}" alt="${alt}"
							${videoSrc ? 'data-video-src="' + videoSrc + '"' : ''}
						/>
					</div>
				`;

				let thumb = `
					<div class="${CLS}-thumb"
						${videoSrc ? 'data-video-src="' + videoSrc + '"' : ''}
					>
						${videoSrc ? '<span class="icon-play"></span>' : ''}
						<img src="${imgThumbSrc}" alt="${alt}"
							${videoSrc ? 'data-video-src="' + videoSrc + '"' : ''}
						/>
					</div>
				`;

				slider.append(slide);
				thumbs.append(thumb);
			}

			// generic slick options
			let $sliderOptions = {
				dots: false,
				arrows: false,
				asNavFor: PG + 'imgThumbs',

			};

			let $thumbsOptionsNav = {
				slidesToShow: $pg.find(PG + 'imgSlider').find(PG + 'slide').length,
				dots: false,
				arrows: false,
				asNavFor: PG + 'imgSlider',
				focusOnSelect: true,

			};

			slider.slick($sliderOptions);
			thumbs.slick($thumbsOptionsNav);

			this.updateSlickOnResize(slider);
			this.updateSlickOnResize(thumbs);
		}

		// get videos for the current variant
		if (res.videos && res.videos.length > 0) {
			for (let i = 0; i < res.videos.length; i++) {
				let videoSrc = res.videos[i].source;
				let thumbSrc = res.videos[i].thumb || res.images[0].thumb;
				let alt = res.videos[i].alt || res.title || '';

				let videoThumb = `
					<div class="${CLS}-videoThumb video-player" data-src="${videoSrc}">
						<img src="${thumbSrc}" alt="${alt}" />
						<span class="icon-play"><span>
					</div>
				`;

				if (thumbs.find('.slick-track').length > 0) {
					thumbs.find('.slick-track').prepend(videoThumb);
				} else {
					thumbs.prepend(videoThumb);
				}

				thumbs.append(`<div class="clearfix"></div>`);
			}
		}

		// if we have variants, we will loop through them and get the slider ready for each variant
		if (res.variants && res.variants.length > 0) {
			// loop through variants
			for (let i = 0; i < res.variants.length; i++) {
				let variantVideos = res.variants[i].videos;
				let variantCode = res.variants[i].code;
				let variantImages = res.variants[i].images;
				let variantPrice = res.variants[i].price;
				let priceDisplay = {};
				let paymentInfo = res.variants[i].paymentInfo;

				if (variantPrice && (variantPrice.isClearancePrice || variantPrice.isKnockDownPrice)) {
					priceDisplay = {
						'sale': `$ ${variantPrice.salePrice.amount}`,
					};
				}

				if (variantPrice && variantPrice.isDiscountPrice) {
					if (variantPrice.showWasNowFlag) {
						priceDisplay = {
							'origin': `$${variantPrice.listPrice.amount}`,
							'sale': `$${variantPrice.salePrice.amount}`,
						};
					} else {
						priceDisplay = {
							'sale': `$${variantPrice.salePrice.amount}`,
						};
					}
				} else {
					priceDisplay = {
						'sale': `$${variantPrice.salePrice.amount}`,
					};
				}

				variantPrice['priceDisplay'] = priceDisplay;
				That.price[variantCode] = variantPrice;

				if (!That.paymentInfo) That.paymentInfo = {};
				That.paymentInfo[variantCode] = paymentInfo;

				// create the variant slider dom element
				slider.after(`<div class="variant-slider" data-variant-code="${variantCode}"></div>`);
				thumbs.after(`<div class="variant-thumbs" data-variant-code="${variantCode}"></div>`);

				if (variantImages && variantImages.length > 0) {
					// loop through variant images
					// create a slider for each variant

					for (let j = 0; j < variantImages.length; j++) {
						let imgSrc = variantImages[j].detail;
						let imgThumbSrc = variantImages[j].thumb;
						let imgZoomSrc = variantImages[j].zoom;
						let alt = variantImages[j].alt || res.title || '';
						let videoSrc = variantImages[j].video || '';

						let slide = `
							<div class="${CLS}-slide">
								${videoSrc ? '<span class="icon-play"></span>' : ''}
								<img data-zoom-image="${imgZoomSrc}" src="${imgSrc}" alt="${alt}" width="770" height="770"
									${videoSrc ? 'data-video-src="' + videoSrc + '"' : ''}
								/>
							</div>
						`;
						let thumb = `
							<div class="${CLS}-thumb">
								${videoSrc ? '<span class="icon-play"></span>' : ''}
								<img src="${imgThumbSrc}" alt="${alt}" width="100" height="100"
									${videoSrc ? 'data-video-src="' + videoSrc + '"' : ''}
								/>
							</div>
						`;

						$pg.find(`.variant-slider[data-variant-code="${variantCode}"]`).append(slide);
						$pg.find(`.variant-thumbs[data-variant-code="${variantCode}"]`).append(thumb);
					}
				}

				// get videos for the current variant
				if (variantVideos && variantVideos.length > 0) {
					for (let i = 0; i < variantVideos.length; i++) {
						let videoSrc = variantVideos[i].source;
						let thumbSrc = variantVideos[i].thumb || variantImages[0].thumb;
						let alt = variantVideos[i].alt || res.title || '';

						let videoThumb = `
							<div class="${CLS}-videoThumb video-player d-none" data-player-variant="${variantCode}" data-src="${videoSrc}">
								<img src="${thumbSrc}" alt="${alt}" />
								<span class="icon-play"><span>
							</div>
						`;
						$pg.find(`.variant-thumbs[data-variant-code="${variantCode}"]`).after(videoThumb);
					}
				}
			}

			// store variants
			That.prodVariants = res.variants;
		}

		That.producItemInfo = res;

		That.setVisibleProduct();
		That.getVariantCode();

		// just in case it was up
		$('.loading-spinner').removeClass('is-active');

		// END of api call processing

		$pg.on('variantChanged', () => {
			// new variant, change the slider
			// const That = this;
			$pg.find('.product-img').parent().find('.zoomIcon').remove();
			let variantCode = this.isBundles ? this.getCurrentVariantBundle() : $pg.attr('data-variant-code');
			let itemQnty = $pg.find('.quantityInput input').val();
			let slider = $pg.find(PG + 'imgSlider');
			let thumbs = $pg.find(PG + 'imgThumbs');
			let variantSlider = $pg.find(`.variant-slider[data-variant-code="${variantCode}"]`);
			let variantThumbs = $pg.find(`.variant-thumbs[data-variant-code="${variantCode}"]`);
			let variantSliderHtml;
			let variantThumbsHtml;

			if (variantSlider.length > 0 && variantThumbs.length > 0) {
				$pg.find('.product-img').addClass('d-none');
				variantSliderHtml = $pg.find(`.variant-slider[data-variant-code="${variantCode}"]`).html();
				variantThumbsHtml = $pg.find(`.variant-thumbs[data-variant-code="${variantCode}"]`).html();
			} else {
				let res = productDetailsJson;
				if (res.images) {
					for (let i = 0; i < res.images.length; i++) {
						let imgSrc = res.images[i].detail;
						let imgThumbSrc = res.images[i].thumb;
						let imgZoomSrc = res.images[i].zoom;
						let alt = res.images[i].alt || res.title || '';
						let videoSrc = res.images[i].video || '';

						variantSliderHtml = `
							<div class="${CLS}-slide" ${i === 0 ? 'itemprop="image"' : ''}>
								${videoSrc ? '<span class="icon-play"></span>' : ''}
								<img data-zoom-image="${imgZoomSrc}" src="${imgSrc}" alt="${alt}"
									${videoSrc ? 'data-video-src="' + videoSrc + '"' : ''}
								/>
							</div>
						`;

						variantThumbsHtml = `
							<div class="${CLS}-thumb"
								${videoSrc ? 'data-video-src="' + videoSrc + '"' : ''}
							>
								${videoSrc ? '<span class="icon-play"></span>' : ''}
								<img src="${imgThumbSrc}" alt="${alt}"
									${videoSrc ? 'data-video-src="' + videoSrc + '"' : ''}
								/>
							</div>
						`;
					}
				}
			}
			// unslick
			if (slider.hasClass('slick-initialized')) {
				slider.slick('unslick');
			}
			if (thumbs.hasClass('slick-initialized')) {
				thumbs.slick('unslick');
			}
			// add content
			slider.html(variantSliderHtml);
			thumbs.html(variantThumbsHtml);
			// init again
			// generic slick options
			let $sliderOptions = {
				dots: false,
				arrows: false,
				asNavFor: PG + 'imgThumbs',

			};
			let $thumbsOptionsNav = {
				slidesToShow: $pg.find(PG + 'imgSlider').find(PG + 'slide').length,
				slidesToScroll: 1,
				dots: false,
				arrows: false,
				asNavFor: PG + 'imgSlider',
				focusOnSelect: true,

			};
			slider.slick($sliderOptions);
			thumbs.slick($thumbsOptionsNav);
			$pg.find(`[data-player-variant="${variantCode}"]`).each(function() {
				let obj = $(this).clone();
				obj.removeClass('d-none');
				thumbs.find('.slick-track').prepend(obj);
				thumbs.append(`<div class="clearfix"></div>`);
			});

			let productObj = {};
			if (this.isBundles) {
				let selectedBundleItemsArr = [];
				let selectedBundleItems = $('.pdp-bundlesItem--variant:visible:not(.is-outOfStock)');
				for (let i=0; i < selectedBundleItems.length; i++) {
					let bundleItem = $(selectedBundleItems[i]);
					let code = bundleItem.data('variant-formattedcode');
					let qty = parseFloat(bundleItem.find('.quantityInput input').val());
					if (qty > 0 && code) {
						selectedBundleItemsArr.push({code: code, quantity: qty});
					}
				}
				productObj = {
					code: null,
					quantity: null,
					size: null,
					items: [selectedBundleItemsArr],
				};
			} else {
				productObj = {
					code: variantCode,
					quantity: itemQnty,
					size: $pg.find('.item-size.is-active-variant').text() || '',
				};
			}

			// if we have a variant selected
			if (That.checkSelectedVariant('gtm')) {
				dataLayer.pushProductView(productObj);
			}

			That.checkWishAndGiftLists();
			That.checkDataNotClickCollect();
			That.checkAUVendor();
			That.updateDeliveryDescription();
		});
	}

	setAUVendor(auVendor = false) {
		const CSS_AU_VENDOR = 'is-au-vendor';
		if (auVendor) {
			this.$pg.addClass(CSS_AU_VENDOR);
		} else {
			this.$pg.removeClass(CSS_AU_VENDOR);
		}
	}

	checkAUVendor() {
		const That = this;
		if (window.enableAustraliaSupplier) {
			const $pg = $(this.$el);
			let optionsSelected = $pg.find(PG + 'variant.pdp-desc-size:not(.d-none) .pdp-options .active');
			let productType = $pg.attr('data-item-type');
			if (productType === 'color') {
				optionsSelected = $pg.find(PG + 'variant.pdp-desc-color .pdp-options .active');
			}
			if (optionsSelected.length) {
				let relatedItemAUVendor = $('.relatedProducts__item.enable-add-cart[data-australianvendor="true"]') || [];
				let auVendor = optionsSelected.attr('data-is-australian-vendor') === 'true';
				if (auVendor || relatedItemAUVendor.length) {
					That.setAUVendor(true);
				} else {
					That.setAUVendor(false);
				}
			} else {
				if (productType === 'generic') {
					// generic
					let auVendor = That.producItemInfo.variants[0].isAustralianVendor;
					That.setAUVendor(auVendor);
				} else {
					That.setAUVendor(false);
				}
			}
		}
	}

	updateSlickOnResize($slick) {
		let slickCurrentSlide = 0;

		$(window).on('resize', _.debounce(function() {
			slickCurrentSlide = $slick.slick('slickCurrentSlide');
			$slick.slick('refresh');
			setTimeout(() => {
				$slick.slick('slickGoTo', slickCurrentSlide);
			}, 200);
		}, 500));
	}

	getCurrentVariantBundle() {
		return this.currentVariantBundle || '';
	}

	bannerText(className, text, customStyle = {}) {
		return `<div class="productItem-labelWrap"><div class="productItem-label productItem-label--${className}" style="${utils.css(customStyle)}"><span>${text}</span></div></div>`;
	}

	multiBannerText(bannerData) {
		return `<div class="productItem-labelWrap">${bannerData.reduce((acc, item) => (acc += `<div class="productItem-label productItem-label--${item.className || ''}" style="${item.customStyle || ''}"><span>${item.text || ''}</span></div>`), '')}</div>`;
	}

	bannerCustom(color, bgColor, text) {
		return `<div style="color: ${color}; background: ${bgColor};" class="productItem-label productItem-label--custom"><span>${text}</span></div>`;
	}

	showPriceText(className, price, isBold) {
		let isBoldClass = isBold ? 'isBold': '';
		let htmlPrice = `<div class="pdp-${className} ${isBoldClass}">${price}</div>`;
		return htmlPrice;
	}

	hasSelectedVariant() {
		const $pg= $(this.$el);
		// check if there are no options selected, then show the displayPrice instead
		let selectedVariant = true;
		// if no options exist, don't check the add to cart
		let optionsCount = $pg.find('.pdp-option:visible').length;
		// if no options has been selected
		if (optionsCount > 0) {
			// color only
			let colorOption = $pg.find(`.${CLS}-options.colors .${CLS}-option.active.is-active-variant:not(.has-sizes)`);
			// color and size
			let colorSizeOption = $pg.find(`.${CLS}-option.has-sizes.active.is-active-variant`);
			// size only
			let sizeOption = $pg.find(`.${CLS}-option.item-size.active.is-active-variant`);
			// generic
			let genericOptions = $pg.find(`.${CLS}-option.generic.active.is-active-variant`);
			// no variant has been selected
			if (
				colorOption.length == 0 &&
				colorSizeOption.length == 0 &&
				sizeOption.length == 0 &&
				genericOptions.length == 0
			) {
				// return false
				selectedVariant = false;
			} else {
				if (colorSizeOption.length != 0) {
					let parentId = colorSizeOption.attr('data-variant-code');
					let sizeOption = $pg.find('[data-parent-itemid="'+parentId+'"]').find('.pdp-option.item-size.active.is-active-variant');
					if (sizeOption.length == 0) {
						// return false
						selectedVariant = false;
					}
				}
			}
		}
		return selectedVariant;
	}

	setPrice() {
		const That = this;
		const $pg= $(this.$el);
		let variantCode = $pg.attr('data-variant-code');
		if ($pg.attr('data-generic-sku') && $pg.attr('data-item-type') == 'generic') {
			variantCode = $pg.attr('data-generic-sku');
		}
		let $wrapperPrice = $pg.find(`.${CLS}-desc-price`);
		let $wrapperBannerText = $pg.find('.img-zoom-outline');
		let priceVariant = That.price && That.price[variantCode];
		let paymentInfoVariant = That.paymentInfo && That.paymentInfo[variantCode];
		let selectedVariant = That.hasSelectedVariant();

		if (priceVariant && selectedVariant) {
			let clearanceMessage = That.producItemInfo && That.producItemInfo.clearanceMessage;
			let knockDownMessage = window.KNOCKDOWN_STYLING.Text;
			const {showWasNowFlag, listPrice, salePrice, isDiscountPrice, isClearancePrice, isKnockDownPrice, isPromotionPrice, saleCode, discountCode, discountBadgeBgColour} = priceVariant;

			(listPrice.amount) ? listPrice.amount = Number(listPrice.amount).toFixed(2) : null;
			(salePrice.amount) ? salePrice.amount = Number(salePrice.amount).toFixed(2) : null;

			let detailDisplay = '';
			let bannerText = '';
			let originPrice = listPrice.amount? That.showPriceText('normalPrice', `Was $${listPrice.amount}`) : '';
			let nowPrice = salePrice.amount? That.showPriceText('nowPrice', `Now $${salePrice.amount}`) : '';
			let normalPrice = salePrice.amount? That.showPriceText('defaultPrice', `$${salePrice.amount}`) : '';
			let nowPriceBold = salePrice.amount? That.showPriceText('nowPrice isBold', `Now $${salePrice.amount}`) : '';
			if (isClearancePrice && isDiscountPrice) {
				detailDisplay = nowPriceBold;
				const banners = [
					{
						className: 'clearance',
						text: 'CLEARANCE',
					},
				];

				banners.push({
					className: 'discount',
					text: `${utils.getDiscountWithClearanceBadgePrefixText(discountCode)}`,
					customStyle: utils.getStyle(window.DISCOUNT_WITH_CLEARANCE_STYLE || {}),
				});

				bannerText = That.multiBannerText(banners);
			} else if (isClearancePrice) {
				detailDisplay = nowPriceBold;
				bannerText = That.bannerText('clearance', 'CLEARANCE');
			} else if (isKnockDownPrice) {
				detailDisplay = nowPriceBold;
				detailDisplay += `<p class="productItem-subTitle">${knockDownMessage ? knockDownMessage : ''}</p>`;
				let banners = [
					{className: 'knockdown', text: window.KNOCKDOWN_STYLING.Badge, customStyle: window.KNOCKDOWN_STYLING.CustomStyle},
				];
				if (discountCode) {
					banners.unshift({className: 'sale', text: `${discountCode}`, customStyle: ''});
				}
				bannerText = That.multiBannerText(banners);
			} else if (isDiscountPrice) {
				bannerText = That.bannerText('sale', utils.getDiscountText(saleCode), { 'background-color': discountBadgeBgColour });
				detailDisplay = nowPriceBold;
			} else if (isPromotionPrice) {
				bannerText = That.bannerText('new', 'HOT PRICE');
				if (showWasNowFlag) {
					detailDisplay = originPrice + nowPrice;
				} else {
					detailDisplay = nowPrice;
				}
			} else {
				detailDisplay = normalPrice;
			}

			That.variantPrice = salePrice.amount;
			$wrapperPrice.html(detailDisplay);
			// Custom badges maximum is 2
			let badgesVariant = That.producItemInfo.variants.filter((variant) => variant.code === variantCode)[0].badges || [];
			let badgeProduct = That.producItemInfo.badges || [];
			let badges = _.uniqBy([...badgesVariant, ...badgeProduct], 'badgeName');
			if (badges.length > 2) {
				badges = _.dropRight(badges);
			}
			if (badges.length > 0) {
				for (let i = 0; i < badges.length; i++) {
					let _badge = badges[i];
					let customElement = That.bannerCustom(_badge.badgeTextColor, _badge.badgeBackgroundColor, _badge.badgeName);
					if (bannerText) {
						let bannerHTML = $.parseHTML(bannerText);
						$(bannerHTML).append(customElement);
						bannerText = bannerHTML[0].outerHTML;
					} else {
						bannerText = `<div class="productItem-labelWrap">${customElement}</div>`;
					}
				}
			}
			$wrapperBannerText.find('.productItem-labelWrap').remove();
			if (bannerText) {
				$wrapperBannerText.append(bannerText);
			}

			// prices for partpayment variants
			if (paymentInfoVariant && paymentInfoVariant.length > 0) {
				for (let i = 0; i < paymentInfoVariant.length; i++) {
					$pg.find(`.paymentInfo-detail[data-name="${paymentInfoVariant[i].name}"] .payment-desc`).html(paymentInfoVariant[i].desc);
				}
			}
		} else {
			// show display price
			if (That.displayPrice) {
				$wrapperPrice.html(`${That.displayPrice}`);
			}

			// display prices for partpayment variants
			if (That.paymentInfoInit && That.paymentInfoInit.length > 0) {
				for (let i = 0; i < That.paymentInfoInit.length; i++) {
					$pg.find(`.paymentInfo-detail[data-name="${That.paymentInfoInit[i].name}"] .payment-desc`).html(That.paymentInfoInit[i].desc);
				}
			}
		}
	}

	getVariantCode() {
		const $pg = $(this.$el);
		const This = this;
		This.getVariantCodeCall();
	}

	getVariantCodeCall() {
		const That = this;
		const $pg = $(this.$el);
		let itemCode = $pg.data('itemCode');
		let prodType = $pg.attr('data-item-type');
		let colorCode = $pg.find(PG + 'options.colors .is-active-variant').attr('data-variant-code');
		let sizeCode = $pg.find(PG + 'options.sizes .is-active-variant').attr('data-variant-code');
		let colorSku = $pg.find(PG + 'options.colors .is-active-variant').attr('data-sku') || null;
		let sizeSku = $pg.find(PG + 'options:not(.d-none) .sizes .is-active-variant').attr('data-sku') || null;
		let genericSku = $pg.attr('data-generic-sku');

		let $data = {
			'itemCode': itemCode,
			'sizeCode': sizeCode,
			'colorCode': colorCode,
		};

		let variantCode;
		switch (prodType) {
			case 'size':
				variantCode = sizeSku;
				break;
			case 'color':
				variantCode = colorSku;
				break;
			case 'colorsize':
				variantCode = sizeSku;
				break;
			case 'generic':
				variantCode = genericSku;
		}

		// for single product it may not have a variantCode and it will taking from itemCode
		if (variantCode) {
			$pg.attr('data-variant-code', variantCode);
		}
	}

	setBonusBuy() {
		const That = this;
		const $pg= $(this.$el);
		let variantCode = $pg.attr('data-variant-code');
		if ($pg.attr('data-generic-sku') && $pg.attr('data-item-type') == 'generic') {
			variantCode = $pg.attr('data-generic-sku');
		}
		let $wrapperBonusBuy = $pg.find(`.${CLS}-bonus-buy`);
		let variantData = That.prodVariants && That.prodVariants.filter((variant) => variant.code === variantCode)[0];
		let selectedVariant = That.hasSelectedVariant();
		let bonusHtml = '';
		const setTempBonus = function(arr) {
			let html = '';
			arr.forEach((item) => {
				const bonusTemp = `<div class="bonus-buy-info">
									<div class="bonus-buy-badge" style="color: ${item.textColor}; background-color: ${item.backgroundColor};">${item.name}</div>
									<div class="badge-desc">
										${item.description} ${item.browseText ? `- <a href="${item.browseUrl}" title="link">${item.browseText}</a>` : ''}
									</div>
								</div>`;
				html = html + bonusTemp;
			});
			return html;
		};
		let bonusBadges = [];
		if (variantData && selectedVariant) {
			bonusBadges = variantData.bonusBuyBadges;
		} else {
			bonusBadges = That.bonusBuyBadges;
		}

		if (bonusBadges.length) {
			bonusHtml = setTempBonus(bonusBadges);
		}
		$wrapperBonusBuy.html(bonusHtml);
	}

	addToBag(productId, size) {
		const $pg = $(this.$el);
		const This = this;
		const $error = $pg.find('.error-messages.add-to-cart-errors');
		const isFitFunction = productId ? true : false;
		// toggle spinners
		$('.loading-spinner').addClass('is-active');

		// reset the error msg
		$error.text('');
		$error.removeClass('is-active');

		if (This.checkSelectedVariant('cart', isFitFunction)) {
			let prop = this.prepareProductProp(productId, size);
			addToCart(prop, () => {
				// success callback
				setTimeout(function() {
					$('.loading-spinner').removeClass('is-active');
				}, 500);
			}, (data) => {
				// fail callback
				// show error div
				$error.addClass('is-active').text(data.message);
				$('.loading-spinner').removeClass('is-active');
			});
		} else {
			return;
		}
	}

	prepareProductProp(productId, size) {
		let selectedBundleItemsArr = [];
		let itemCode = this.$pg.attr('data-variant-code');
		if (this.prodType == 'generic') {
			itemCode = this.$pg.attr('data-generic-sku');
		}

		let itemQnty = '1';
		if (!productId) {
			itemQnty = this.$pg.find('.quantityInput input').val();
		}
		let data = {
			'code': productId || itemCode,
			'quantity': itemQnty,
		};

		// push data to dataLayer to Google Tag Manager
		let productObj = {};
		if (this.isBundles) {
			// add to cart for bundles
			const selectedBundleItems = $('.pdp-bundlesItem--variant');
			for (let i=0; i < selectedBundleItems.length; i++) {
				const bundleItem = $(selectedBundleItems[i]);
				const quantityInput = bundleItem.find('.quantityInput input');
				const code = bundleItem.data('variant-formattedcode');
				const qty = parseFloat(quantityInput.length ? quantityInput.val() : 0);
				if (qty > 0 && code) {
					selectedBundleItemsArr.push({code: code, quantity: qty});
				}
			}
			productObj = {
				code: null,
				quantity: null,
				size: null,
				items: [selectedBundleItemsArr],
			};
			data['items'] = selectedBundleItemsArr;
			this.bundleAddToCart = true;
			dataLayer.pushAddToCart(productObj);
		} else {
			// add to cart productdetails
			let productObj = {
				code: itemCode,
				quantity: itemQnty,
				size: this.$pg.find('.item-size.is-active-variant').text() || '',
			};

			dataLayer.pushAddToCart(productObj);
		}

		this.bundleAddToCart = false;

		return {
			endpoint: this.isBundles ? $('.endpoints-definition').data('add-to-cart-bundle-endpoint') : $('.endpoints-definition').data('add-to-bag-endpoint') || '',
			code: data.code,
			quantity: data.quantity,
			size: size || data.size || '',
			datalayerDataSource: '',
			title: this.$pg.find('.prod-title').text() || '',
			cartLink: this.$pg.data('cartLink') || '#',
			prodImg: this.$pg.find('.product-img').attr('src') || '',
			items: data.items,
			isBundles: this.isBundles,
		};
	}

	subscribeToNewsletter() {
		const $pg = $(this.$el);
		const This = this;
		// toggle spinners
		$('.loading-spinner').addClass('is-active');

		This.subscribeToNewsletterCall().then((data) => {
			if (data.result == 'SUCCESS') {
				$pg.find('.newsletter .success-messages').addClass('is-active').text(data.message);
				$pg.find('.newsletter input, .newsletter button[type="submit"]').prop('disabled', true);
				// toggle spinners
				$('.loading-spinner').removeClass('is-active');
			} else {
				// show error div
				$pg.find('.newsletter .error-messages').addClass('is-active').text(data.message);
				$('.loading-spinner').removeClass('is-active');
			}
		});
	}

	subscribeToNewsletterCall() {
		const $pg = $(this.$el);
		let $email = $pg.find('#email').val();
		let $subscribeEndpoint = $pg.find('form.newsletter').attr('action');
		let $data = {
			'email': $email,
		};
		return Api.callApi($subscribeEndpoint, $data);
	}

	initFormValidationConstraints() {
		let $form = $(this.$el).find('form.newsletter');
		if ($form.length > 0) {
			utils.formValidation($form[0], this);
		}
	}

	formSuccessCallback(form) {
		let This = this;
		// check form type
		if ($(form).hasClass('newsletter')) {
			// api call
			This.subscribeToNewsletter();
		} else {
			$(form).submit();
		}
	}

	showPopper(data) {
		// register the template
		let partial = require('../../../widgets/notifications/tmpl/notifications.hbs');
		Handlebars.registerPartial('notifications', partial);
		let theTemplateScript = `
			{{> notifications wg="notifications" ns="Notifications" }}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(theTemplateScript))();
		let theTemplate = Handlebars.template(precompiled);
		let theCompiledHtml = theTemplate(data);
		$(document).find('body').append(theCompiledHtml);
		// Re-init script for notifications widget
		loadNotifications(document.body, false, true).then((wg) => {
			wg ? wg.init(data.recommendationsApi) : '';
		}).catch((error) => `${error} An error occurred while loading notifications script`);
	}

	handleCloseImgViewer(imgViewer, sliderHolder, thumbsHolder ) {
		imgViewer.removeClass('is-active');
		if (sliderHolder.hasClass('slick-initialized')) {
			sliderHolder.slick('unslick');
		}
		if (thumbsHolder.hasClass('slick-initialized')) {
			thumbsHolder.slick('unslick');
		}
		// destroy all prev zoom stuff
		sliderHolder.find('.zoom').each(function() {
			$(this).trigger('zoom.destroy');
		});
		// empty html
		sliderHolder.html('');
		thumbsHolder.html('');
	}

	setImageViewer() {
		const That = this;
		const $pg = $(this.$el);
		let imgViewer = $pg.find('.productDetailsPage-imageViewer');
		let closeImgViewer = imgViewer.find('.icon-close');
		let sliderHolder = imgViewer.find('.slider-holder');
		let thumbsHolder = imgViewer.find('.thumbs-holder');
		let zoomMsg = 'Tap and move your finger around the image to zoom';

		// get clicks on the close icon
		closeImgViewer.on('click', function() {
			That.handleCloseImgViewer(imgViewer, sliderHolder, thumbsHolder );
		});

		// get clicks on product images / slider images
		$pg.on('click', `${PG}imgSlider .slick-slide, .product-img`, function() {
			let currenSlideIndex = Number($(`${PG}imgThumbs .slick-slide.slick-current`).attr('data-slick-index'));

			// toggle the image view
			imgViewer.addClass('is-active');
			// show spinners
			$('.loading-spinner').addClass('is-active');
			// check if it's a static image without a slider
			let imageCheck = $(this).hasClass('product-img');
			let $target = $(this);
			let isImg = this.tagName === 'IMG';
			if (!isImg) {
				$target = $(this).find('img');
			}

			let targetVideoSrc = $target.data('video-src') || '';

			if (imageCheck) {
				let zoomImg = $(this).data('zoomImage') || $(this).attr('src');
				let alt = $(this).attr('alt') || $pg.find('.prod-title').text() || '';
				sliderHolder.append(`<span class="message-zoom">${zoomMsg}</span><span class="zoom"><img src="${zoomImg}" alt="${alt}" /></span>`);
				sliderHolder.addClass('is-fullHeight');
				thumbsHolder.hide();
				$('.loading-spinner').removeClass('is-active');
			} else {
				sliderHolder.removeClass('is-fullHeight');
				thumbsHolder.show();
				// fill up the slider and thumbs area
				let slides = $pg.find(PG + 'imgSlider');
				let thumbs = $pg.find(PG + 'imgThumbs');
				slides.find('.slick-slide:not(.slick-cloned) img').each(function() {
					let $img = $(this);
					let zoomImg = $img.data('zoomImage') || $img.attr('src');
					let alt = $img.attr('alt') || $pg.find('.prod-title').text() || '';
					let videoSrc = $img.data('video-src') || '';
					let tmpl = '';

					if (videoSrc) {
						tmpl = `
							<div>
								<div class="productDetailsPage-videoZoomWrap">
									<video class="productDetailsPage-videoZoom" controls="controls" src="${videoSrc}"></video>
								</div>
							</div>
						`;
					} else {
						tmpl = `
							<div>
								<span class="message-zoom">${zoomMsg}</span>
								<span class="zoom">
									<img src="${zoomImg}" alt="${alt}" />
								</span>
							</div>
						`;
					}

					sliderHolder.append(tmpl);
				});

				thumbs.find('.slick-slide:not(.slick-cloned) img').each(function() {
					let $img = $(this);
					let thumbImg = $img.attr('src');
					let alt = $img.attr('alt') || $pg.find('.prod-title').text() || '';
					let videoSrc = $img.data('video-src') || '';
					let tmpl = `
						<div class="productDetailsPage-imgZoomWrap">
							${videoSrc ? '<span class="icon-play"></span>' : ''}
							<img src="${thumbImg}" alt="${alt}" />
						</div>
					`;
					thumbsHolder.append(tmpl);
				});

				// generic slick options
				let $sliderOptions = {
					// infinite: false,
					dots: false,
					arrows: true,
					asNavFor: '.thumbs-holder',
					initialSlide: currenSlideIndex,
					responsive: [
						{
							breakpoint: 786,
							settings: {
								touchMove: false,
								swipe: false,
							},
						},
					],
				};

				let $thumbsOptionsNav = {
					slidesToShow: Math.floor($(window).width() / 80),
					dots: false,
					arrows: true,
					asNavFor: '.slider-holder',
					focusOnSelect: true,
					touchMove: false,
					initialSlide: currenSlideIndex,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								touchMove: false,
								swipe: false,
							},
						},
					],
				};

				// wait for all images to load
				// then init sliders

				let images = sliderHolder.find('img');
				let imagesLoaded = 0;
				let totalImages = images.length;

				sliderHolder.off().on('init', () => {
					$('.loading-spinner').removeClass('is-active');
					// if (targetVideoSrc) {
					// 	$(`.${CLS}-videoZoom`).trigger('play');
					// }
				});

				images.each(function() {
					let imgSrc = $(this).attr('src');
					let objImg = new Image();
					objImg.src = imgSrc;
					objImg.onload = function() {
						imagesLoaded++;
						if (imagesLoaded == totalImages) {
							// init slides
							sliderHolder.slick($sliderOptions);
							thumbsHolder.slick($thumbsOptionsNav);
						}
					};
				});

				sliderHolder.on('beforeChange', () => {
					$(`.productDetailsPage-videoZoom`).trigger('pause');
				});

				// init zoom
				if (sliderHolder.find('.zoom').length > 0) {
					if (utils.isOnMobileSmaller()) {
						sliderHolder.find('.zoom').each(function() {
							$(this).closest(PG + 'imageViewer').addClass('zoomWrapper');
							let zoomImg = $(this).find('img').attr('src');
							$(this).zoom({
								on: 'grab',
								url: zoomImg,
								magnify: 1.2,
							});
						});
					}
				}

				// re-calculate width
				$(window).trigger('resize');
			}
		});

		// $(window).trigger('resize');

		$(window).on('resize', function() {
			if (utils.isOnMobileSmaller()) {
				sliderHolder.find('img').not('.zoomImg').css({
					'max-height': sliderHolder.height() - 100,
				});
			} else {
				sliderHolder.find('img').not('.zoomImg').attr('style', '');
			}
		});

		// handle click outside
		imgViewer.on('click', '.slider-holder', function(event) {
			if ($(event.target).closest(`.zoom, .productDetailsPage-videoZoom`).length === 0 && $(event.target).closest(`.slick-arrow`).length !== 1) {
				That.handleCloseImgViewer(imgViewer, sliderHolder, thumbsHolder);
			}
		});
	}

	handleWishlistBtn($btn) {
		const $pg = $(this.$el);
		const This = this;
		let qty = 1;

		// check if is already added to wishlist
		if (!$btn.hasClass(CLS_LIST_ADDED)) {
			if (This.checkSelectedVariant('wishlist')) {
				let code = $pg.attr('data-variant-code');
				if (This.prodType == 'generic') {
					code = $pg.attr('data-generic-sku');
				}
				let param = {
					code: code,
					qty: qty,
				};
				let addEnpoint = $pg.data('addToWishlistEndpoint');
				window.itemTitle = $pg.find('.prod-title').text();
				window.itemImg = $pg.find('.product-img').attr('src');
				wishlist.add($pg, $btn, addEnpoint, param).then((lineItemId) => {
					This.variantStates.lineItemId = lineItemId;
				});
			}
		} else {
			let lineItemId = This.variantStates.lineItemId;
			let removeEnpoint = $pg.data('removeFromWishlistEndpoint');
			let param = {
				code: lineItemId,
				qty: qty,
			};
			wishlist.remove($pg, $btn, removeEnpoint, param);
		}
	}

	handleGiftRegistry($btn) {
		const $pg = $(this.$el);
		const This = this;
		if (!This.checkSelectedVariant('gift registry')) return;


		if (!$btn.hasClass(CLS_LIST_ADDED)) {
			const addEnpoint = $pg.data('addToGiftRegistryEndpoint');
			let code = $pg.attr('data-variant-code');
			let qty = $pg.find('.quantityInput input').val();

			if (This.prodType == 'generic') {
				code = $pg.attr('data-generic-sku');
			}
			let param = {
				id: code,
				quantity: qty,
			};
			giftRegistry.add($pg, addEnpoint, param, (data) => {
				let res = data.response;
				let details = {
					mods: data.message ? 'has-error' : '',
					title: $pg.find('.prod-title').text(),
					addedText: 'Added to gift registry',
					qty: data.quantityActual,
					itemImg: $pg.find('.product-img').attr('src'),
					errorMsg: data.message,
					recommendationsApi: utils.getRecommendationsApi(res.recommendationsApi || ''),
					recommendationsTitle: res.recommendationsTitle || '',
					recommendationsViewMoreLink: res.recommendationsViewMoreLink || '',
					recommendationsProducts: data.code,
				};
				This.showPopper(details);

				if (data.result == 'SUCCESS') {
					$btn.addClass(CLS_LIST_ADDED);
					This.variantStates.giftRegistryLineItemId = data.lineItemId;
					This.variantStates.giftRegistryId = data.giftRegistryId;
				} else {
					$btn.removeClass(CLS_LIST_ADDED);
				}
			});
		} else {
			const removeEnpoint = $pg.data('removeGiftRegistryEndpoint');
			let param = {
				id: This.variantStates.giftRegistryLineItemId,
				giftRegistryId: This.variantStates.giftRegistryId,
			};
			giftRegistry.remove($pg, removeEnpoint, param, (data) => {
				if (data.result == 'SUCCESS') {
					$btn.removeClass(CLS_LIST_ADDED);
				}
			});
		}
	}

	checkSelectedVariant(state, isFA) {
		if (isFA) return true;
		const This = this;
		const $pg = $(this.$el);
		let errorDiv = $pg.find('.error-messages.add-to-cart-errors');
		let errorMsg = `Please select product options before adding this product to your ${state}`;
		let errorQtyMsg = this.isBundles ? `Please select at least one bundle item before adding to ${state}` : `Please select at least one item before adding to ${state}`;

		// reset errors
		errorDiv.removeClass('is-active').text('');

		// if no options exist, don't check the add to cart
		let optionsCount = $pg.find('.pdp-option:visible').length;
		// if no options has been selected
		if (optionsCount > 0) {
			// color only
			let colorOption = $pg.find(`.${CLS}-options.colors .${CLS}-option.active.is-active-variant:not(.has-sizes)`);
			// color and size
			let colorSizeOption = $pg.find(`.${CLS}-option.has-sizes.active.is-active-variant`);
			// size only
			let sizeOption = $pg.find(`.${CLS}-option.item-size.active.is-active-variant`);
			// generic
			let genericOptions = $pg.find(`.${CLS}-option.generic.active.is-active-variant`);

			// no variant has been selected
			if (!colorOption.length && !colorSizeOption.length && !sizeOption.length && !genericOptions.length) {
				// show error message
				this.showErrorMessage(state, errorDiv, errorMsg);
			} else {
				if (this.isBundles) {
					// only for bundle
					let bundleColorOption = $pg.find(`.${CLS}-options.colors`);
					let bundleSizeOption = $pg.find(`.${CLS}-options.sizes`);

					if (bundleColorOption.length || bundleSizeOption.length) {
						if ( (bundleColorOption.length && bundleSizeOption.length ) &&
							(!bundleColorOption.find('.active').length || !bundleSizeOption.find('.active').length)) {
								// show error message
								this.showErrorMessage(state, errorDiv, errorMsg);
						} else if ((bundleColorOption.length && !bundleSizeOption.length) && !bundleColorOption.find('.active').length) {
								// show error message
								this.showErrorMessage(state, errorDiv, errorMsg);
						} else if ((!bundleColorOption.length && bundleSizeOption.length) && !bundleSizeOption.find('.active').length) {
								// show error message
								this.showErrorMessage(state, errorDiv, errorMsg);
						} else {
							if ($(PG + 'bundlesItem.productItem:visible').length) {
								if (this.hasSelectedProductQuantity()) {
									return true;
								} else {
									// show error message
									this.showErrorMessage(state, errorDiv, errorQtyMsg);
								}
							} else {
								$('.loading-spinner').removeClass('is-active');
								errorDiv.addClass('is-active').text(errorMsg);
								This.scrollToErrorMessage(errorDiv);
								return false;
							}
						}
					} else {
						if ($(PG + 'bundlesItem.productItem:visible').length) {
							if (this.hasSelectedProductQuantity()) {
								return true;
							} else {
								// show error message
								this.showErrorMessage(state, errorDiv, errorQtyMsg);
							}
						} else {
							$('.loading-spinner').removeClass('is-active');
							errorDiv.addClass('is-active').text(errorMsg);
							This.scrollToErrorMessage(errorDiv);
							return false;
						}
					}
				} else {
					// for product details
					if (colorSizeOption.length != 0) {
						let parentId = colorSizeOption.attr('data-variant-code');
						let sizeOption = $pg.find('[data-parent-itemid="'+parentId+'"]').find('.pdp-option.item-size.active.is-active-variant');
						if (sizeOption.length == 0) {
							// show error message
							this.showErrorMessage(state, errorDiv, errorMsg);
						} else {
							if (this.hasSelectedProductQuantity()) {
								return true;
							} else {
								// show error message
								this.showErrorMessage(state, errorDiv, errorQtyMsg);
							}
						}
					} else {
						if (this.hasSelectedProductQuantity()) {
							return true;
						} else {
							// show error message
							this.showErrorMessage(state, errorDiv, errorQtyMsg);
						}
					}
				}
			}
		} else {
			if (this.hasSelectedProductQuantity()) {
				return true;
			} else {
				// show error message
				this.showErrorMessage(state, errorDiv, errorQtyMsg);
			}
		}
	}

	setAppearanceBundlesVariants() {
		// only for bundles
		if (this.isBundles) {
			const $pg = $(this.$el);
			let optionsColorsWrapper = $pg.find(PG + 'options.colors');
			let producItemBundles = $pg.find(PG + 'bundlesItem.productItem');
			let bundlesItemVariants = $pg.find(PG + 'bundlesItem--variant');

			// reset the previous selected
			producItemBundles.find(PG + 'bundlesItem--variant.is-outOfStock .pdp-bundlesItem_price').removeClass('d-none');
			producItemBundles.find(PG + 'bundlesItem--variant.is-outOfStock').removeClass('is-outOfStock');
			producItemBundles.find('.productItem-label-outofstock').remove();
			producItemBundles.find('.btn-up').removeClass('disabled');
			producItemBundles.find('input[type="number"]').prop('disabled', false);

			// reset Sizes select

			if (optionsColorsWrapper.length) {
				const colorName = optionsColorsWrapper.find(PG + 'option.active').attr('data-item-description');
				if (colorName) {
					producItemBundles.find(`${PG}bundlesItem--variant[data-variant-color="${colorName}"]`).removeClass('d-none');
					producItemBundles.find(`${PG}bundlesItem--variant:not([data-variant-color="${colorName}"]):not([data-variant-color="undefined"])`).addClass('d-none');
				}
			}
			this.toggleVariantOOS();
			// payment info
			this.calculatePaymentInfo();
			// Disable Add to cart if all products is out of stock
			this.handleAddToCartOOS();
		}
	}

	toggleVariantOOS() {
		if (this.isBundles) {
			$(this.$el).find(PG + 'bundlesItem.productItem').each(function() {
				const $item = $(this);
				const hasVariantVisible = $item.find(PG + 'bundlesItem--variant:visible').length;
				if (hasVariantVisible) {
					$item.find(PG + 'bundlesItem--oos').addClass('d-none');
				} else {
					$item.find(PG + 'bundlesItem--oos').removeClass('d-none');
				}
			});
		}
	}

	handleAddToCartOOS() {
		const $pg = $(this.$el);
		let productItemBundles = $pg.find(PG + 'bundlesItem.productItem');
		let currentList = productItemBundles.find('> ul > li:not(.d-none)');
		let numberOutOfStock = 0;
		for (let i = 0; i < currentList.length; i ++) {
			let labels = $(currentList[i]).find('.pdp-bundlesItem_product-label .productItem-label');
			let outOfStocks = labels.filter((i, el) => $(el).text() === 'OUT OF STOCK');
			if (outOfStocks.length) {
				numberOutOfStock ++;
			}
		}
		let btnAddToCart = $pg.find('.add-to-cart');
		if (numberOutOfStock === productItemBundles.length) {
			btnAddToCart.attr('disabled', true);
		} else {
			if (btnAddToCart.attr('disabled')) {
				btnAddToCart.removeAttr('disabled');
			}
		}
	}

	scrollToErrorMessage(errorDiv) {
		if (errorDiv.length > 0) {
			$('html, body').animate({
				scrollTop: errorDiv.offset().top - $(document).find('.siteHeader').height() - 16, // a bit of a margin
			});
		}
	}

	checkWishAndGiftLists() {
		const That = this;
		const $pg = $(this.$el);
		let variant = $pg.attr('data-variant-code');

		if (variant && variant != '') {
			// get wishList and giftList states for the selected variant
			That.getVariantWishListAndGiftState(variant).then((data) => {
				if (data.result == 'SUCCESS') {
					That.variantStates = data.response;
					That.handleWishListAndGiftVariantObj();
				}
			});
		}
	}

	getVariantWishListAndGiftState(variant) {
		let $endpoint = $(this.$el).data('getWishlistGiftlistStatesEndpoint');
		return Api.getApi($endpoint + variant);
	}

	handleWishListAndGiftVariantObj() {
		const That = this;
		const $pg = $(this.$el);
		let variantObj = That.variantStates;

		if (variantObj.isAddedIntoGiftRegistry) {
			$pg.find('.addToGiftBtn').addClass(CLS_LIST_ADDED);
		} else {
			$pg.find('.addToGiftBtn').removeClass(CLS_LIST_ADDED);
		}

		if (variantObj.isAddedIntoWishlist) {
			$pg.find('.wishlistBtn').addClass(CLS_LIST_ADDED);
		} else {
			$pg.find('.wishlistBtn').removeClass(CLS_LIST_ADDED);
		}
	}

	setReviews() {
		const $pg = $(this.$el);

		let options = {
			page: 10,
			pagination: [{
				name: 'pagination-top',
				paginationClass: 'pagination-top',
				innerWindow: 4,
			}, {
				paginationClass: 'pagination-bottom',
				innerWindow: 4,
			}],
		};

		this.list = new List('reviewsList', options);
		this.setPaginationPrev();
		this.setPaginationNext();


		const totalPages = $pg.find('.pagination-top li').length;

		if (!totalPages || totalPages < 2) {
			$pg.find(PG + 'reviewsSec-paging').addClass('d-none');
		}

		this.list.on('updated', () => {
			this.scrollToTop();
		});
	}

	getPageIndexes() {
		const page = this;
		const total = page.$el.querySelectorAll('.pagination-top .page').length;
		const current = parseInt(page.$el.querySelector('.pagination-top .active .page').innerText);
		const prev = current > 1 ? current - 1 : null;
		const next = current < total ? current + 1 : null;
		return {total, current, prev, next};
	}

	setPaginationPrev() {
		const that = this;
		$('.pagination-prev').on('click', function(e) {
			const pageIndexes = that.getPageIndexes();
			const totalItems = that.list.page;
			const index = ((pageIndexes.current - 1) * totalItems) - totalItems + 1;
			pageIndexes.prev ? that.list.show(index, 10) : '';

			that.scrollToTop();
		});
	}

	setPaginationNext() {
		const that = this;
		$('.pagination-next').on('click', function(e) {
			const pageIndexes = that.getPageIndexes();
			const totalItems = that.list.page;
			const index = ((pageIndexes.current - 1) * totalItems) + totalItems + 1;
			pageIndexes.next ? that.list.show(index, 10) : '';

			that.scrollToTop();
		});
	}

	scrollToTop() {
		$('html, body').animate({
			scrollTop: $(PG + 'reviewsSec').offset().top,
		}, 500);
	}

	calculatePaymentInfo() {
		let $pg = $(this.$el);
		let $price = 0;
		let activeSelectedBundles = $pg.find(PG + 'bundlesItem--variant:not(.d-none)');
		activeSelectedBundles.each((i, a)=> {
			let $el = $(a);
			let $qty = parseFloat($el.find('input[type="number"]').val());
			let $elPrice = parseFloat($el.data('variant-price'));
			if ($qty > 0) {
				$price = $price + ($elPrice * $qty);
			}
		});
		let obj = $pg.find(PG + 'bundle-items').data('payment-info');
		let productDetailsPagePaymentInfo = $pg.find(PG + 'paymentInfo');
		for (let [key, value] of Object.entries(obj)) {
			if ($price > 0) {
				productDetailsPagePaymentInfo
					.find(`.paymentInfo-detail[data-name="${key}"]`)
					.find('.payment-desc strong').html(`${($price/value).toFixed(2)}`);
			} else {
				productDetailsPagePaymentInfo
					.find(`.paymentInfo-detail[data-name="${key}"]`)
					.find('.payment-desc strong').html('0.00');
			}
		}
	}

	setOutOfStock($element) {
		let labelWrap = $element.find('.productItem-labelWrap');
		let price = $element.find('.pdp-bundlesItem_price');
		$element.addClass('is-outOfStock');
		$element.find('.btn-up, .btn-down').addClass('disabled');
		$element.find('input[type="number"]').prop('disabled', true);
		if (!labelWrap.find('.productItem-label-outofstock').length) {
			labelWrap.append('<div class="productItem-label productItem-label--default productItem-label-outofstock"><span>OUT OF STOCK</span></div>');
			price.addClass('d-none');
		}
	}

	initBundlesQtyButtons() {
		let $pg = $(this.$el);
		let qtyBlk = '.quantityInput:not(.related-input)';
		$pg.find(`${qtyBlk} .btn-up, ${qtyBlk} .btn-down`).on('click', () => {
			if (this.isBundles) {
				this.calculatePaymentInfo();
			}
			this.checkStockStatus();
			this.checkFreeDelivery();
		});
		$pg.find(`${qtyBlk} input`).on('change', () => {
			this.checkStockStatus();
			this.checkFreeDelivery();
		});
	}

	hasSelectedProductQuantity() {
		let $pg = $(this.$el);
		let qty = 0;
		let activeSelectedBundles = $pg.find('.quantityInput input[type="number"]:visible');
		activeSelectedBundles.each((i, a)=> {
			let $qty = parseFloat($(a).val());
			let sizeSelected = this.isBundles ? !!$(a).closest('.pdp-bundlesItem--variant').data('variant-formattedcode') : true;
			if ($qty > 0 && sizeSelected) {
				qty = qty + $qty;
			}
		});
		if (qty > 0) {
			return true;
		} else {
			return false;
		}
	}

	showErrorMessage(state, errorDiv, errorMsg) {
		const that = this;
		if (state !== 'gtm') {
			errorDiv.addClass('is-active').text(errorMsg);
			$('.loading-spinner').removeClass('is-active');
			that.scrollToErrorMessage(errorDiv);
		}
		return false;
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_06/_work/151/s/FrontEnd/src/views/pages/productDetailsPage/js/productDetailsUpdate2022.js